import { AUTH_ACTIONS } from '../constants/action.constants';
import { getToken } from '../services/session.storage';

const initialState = {
  authenticated: !!getToken(),
  env: '',
  user: {
    firstName: '',
    lastName: '',
    userName: '',
    permissions: []
  }
};

const authentication = (state = initialState, action = {}) => {
  switch (action.type) {
    case AUTH_ACTIONS.SUCCESS:
      return {
        ...state,
        authenticated: true,
        env: action.data.env,
        user: {
          ...action.data.user,
          permissions: action.data.permissions,
          permissionsWithTreepaths: action.data.permissionsWithTreepaths
        }
      };
    case AUTH_ACTIONS.RESET:
      return { ...initialState, authenticated: false };
    case 'DEV_AUTH_UPDATE_PERMISSIONS':
      return {
        ...state,
        user: {
          ...state.user,
          permissions: state.user.permissions?.includes(action.permission)
            ? state.user.permissions?.filter((p) => p !== action.permission)
            : [...state.user.permissions, action.permission]
        }
      };
    default:
      return state;
  }
};

export default authentication;
